var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import delay from './delay';
const minDelay = (promise, minimumDelay) => __awaiter(void 0, void 0, void 0, function* () {
    const options = {
        delayRejection: true,
    };
    let promiseError;
    if (options.delayRejection) {
        promise = promise.catch(error => {
            promiseError = error;
        });
    }
    const value = yield Promise.all([promise, delay(minimumDelay)]);
    return promiseError ? Promise.reject(promiseError) : value[0];
});
export default minDelay;
//# sourceMappingURL=min-delay.js.map